import { useMemo } from 'react';

import { fmtDate } from '../utils/features';

import '../styles/sg.css';

// Mini-gráfica de tendencia (D-005): polilínea SVG SIN dependencia (nada de recharts).
// Recibe los eventos YA CARGADOS de la pestaña de historial + la config `chart` de la
// feature ({ field, unit, label }). Ordena asc por `event_date`, salta valores null /
// no numéricos y solo dibuja con ≥2 puntos (si no, no renderiza nada). La serie
// refleja lo cargado/filtrado (la paginación del historial acota la serie — decisión
// de la tarea: se grafica lo cargado).

const W = 100;   // viewBox lógico; el ancho real es responsive (preserveAspectRatio none)
const H = 32;
const PAD = 2;

export default function SgTrend({ rows, chart }) {
    const points = useMemo(() => {
        const list = (rows ?? [])
            .filter((ev) => ev?.event_date != null)
            // OJO: Number(null) === 0 — descartar null/undefined/'' ANTES de coercer,
            // o un valor ausente se graficaría como 0 y arrastraría el mínimo.
            // `chart.field` es el nombre de un campo del payload o una FUNCIÓN (payload) => valor,
            // para métricas DERIVADAS (los litros/día de leche son la suma de ordeños, no un campo).
            .map((ev) => ({
                date: ev.event_date,
                raw: typeof chart.field === 'function' ? chart.field(ev.payload) : ev.payload?.[chart.field],
            }))
            .filter((p) => p.raw !== null && p.raw !== undefined && p.raw !== '')
            .map((p) => ({ date: p.date, value: Number(p.raw) }))
            .filter((p) => Number.isFinite(p.value));
        list.sort((a, b) => (a.date < b.date ? -1 : a.date > b.date ? 1 : 0));
        return list;
    }, [rows, chart]);

    if (points.length < 2) return null;

    const values = points.map((p) => p.value);
    const min = Math.min(...values);
    const max = Math.max(...values);
    const span = max - min;

    // y: [min,max] → [H-PAD, PAD] (serie plana → línea al medio). x: espaciado uniforme.
    const y = (v) => (span === 0 ? H / 2 : H - PAD - ((v - min) / span) * (H - PAD * 2));
    const x = (i) => PAD + (i / (points.length - 1)) * (W - PAD * 2);
    const path = points.map((p, i) => `${x(i).toFixed(2)},${y(p.value).toFixed(2)}`).join(' ');

    const first = points[0];
    const last = points[points.length - 1];

    return (
        <div className="sg-trend">
            <div className="sg-trend__head">
                <span className="sg-trend__label">{chart.label}</span>
                <span className="sg-trend__meta">
                    Mín {min} {chart.unit} · Máx {max} {chart.unit} · Último <b>{last.value} {chart.unit}</b>
                </span>
            </div>
            <svg className="sg-trend__svg" viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none" role="img" aria-label={chart.label}>
                <polyline className="sg-trend__line" points={path} fill="none" vectorEffect="non-scaling-stroke" />
            </svg>
            <div className="sg-trend__range">
                <span>{fmtDate(first.date)}</span>
                <span>{fmtDate(last.date)}</span>
            </div>
        </div>
    );
}
